import authenticated from './http-clients/authenticated'

const _url = '/tenants'

export default {
  index(params) {
    let url = '/tenants?paginate=true'

    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({ id }) {
    return authenticated({
      url: `${_url}/${id}`,
      method: 'get'
    })
  },
  store({ data }) {
    return authenticated({
      url: _url,
      method: 'post',
      data
    })
  },
  update({ id, data }) {
    return authenticated({
      url: `${_url}/${id}`,
      method: 'patch',
      data
    })
  },
  destroy({ id }) {
    return authenticated({
      url: `${_url}/${id}`,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/tenants.js